const getOrderLineModifiers1 = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine && indexOrderLine.Modifiers) {
      return typeof indexOrderLine.Modifiers === 'object'
        ? indexOrderLine.Modifiers[0] : indexOrderLine.Modifiers.slice(0, 2);
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => (typeof item.Modifiers === 'object'
      ? item.Modifiers[0] : item.Modifiers.slice(0, 2)).join(', '))
    : null;
};

export default getOrderLineModifiers1;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineModifiers1.js